var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative z-1",staticStyle:{"background-color":"#e2e2e2","min-height":"4px"}},[_c('client-only',[_c('ProgressBar',{attrs:{"bar-color":_vm.barColor,"bg-color":"#e2e2e2","val":_vm.progress,"size":"small","text":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }